import styled from 'styled-components/macro'

export const Container = styled.div``

export const Title = styled.p``

export const Group = styled.div``

export const SubTitle = styled.div``

export const Text = styled.p``
export const Feature = styled.div``
export const FeatureText = styled.p``
export const FeatureTitle = styled(Title)``
export const FeatureClose = styled.button``
export const Maturity = styled.div``
export const Content = styled.div``
export const Meta = styled.div``
export const Entities = styled.div``
export const Item = styled.div``
export const Image = styled.img``
